import { ReactNode, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../../store";
import { searchActions } from "../../store/search-slice";
import { AddButton } from "../AddButton/AddButton";
import Search from "../Search/Search";

import styles from "./sub-menu.module.css";

type SubMenuProps = {
  children: ReactNode;
  showSearchButton: boolean;
  handleAdd?: () => void;
  stretched?: boolean;
};

export const SubMenu = ({
  children,
  showSearchButton,
  handleAdd,
  stretched = false,
}: SubMenuProps): JSX.Element => {
  const isSearchExpanded = useSelector(
    (state: RootState) => state.search.isExpanded
  );
  const isAdmin = useSelector((state: RootState) =>
    state.user.roles.some((role) => role === "admin" || role === "kunde.admin")
  );

  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(searchActions.setIsExpanded(false));
      dispatch(searchActions.setSearchValue(""));
    };
  }, []);

  return (
    <div className={styles["sub-menu"]}>
      <h3
        className={`${styles["sub-menu__label"]} ${
          stretched && styles["sub-menu__label--stretched"]
        } ${isSearchExpanded && styles["sub-menu__label--hide"]}`}
      >
        {children}
      </h3>
      <div className={styles["sub-menu__buttons"]}>
        {showSearchButton && <Search />}
        {handleAdd && isAdmin && (
          <AddButton
            background="light"
            iconColor="dark"
            onClick={handleAdd}
            selected={false}
          />
        )}
      </div>
    </div>
  );
};
